var map = {
	"./": 64795,
	"./SwapAuth": 39870,
	"./SwapAuth.ts": 39870,
	"./arbeth": 23789,
	"./arbeth.ts": 23789,
	"./bnb": 52723,
	"./bnb.ts": 52723,
	"./btc": 91995,
	"./btc.ts": 91995,
	"./eth": 62984,
	"./eth.ts": 62984,
	"./ghost": 5914,
	"./ghost.ts": 5914,
	"./index": 64795,
	"./index.ts": 64795,
	"./matic": 8746,
	"./matic.ts": 8746,
	"./next": 57209,
	"./next.ts": 57209
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92273;